import React, { useEffect } from 'react';

import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';

import Icon from 'components/icon/icon';

interface TimeUnitInputProps {
  value?: string;
  onChange?: (target: { name: 'hour' | 'minute'; value?: Dayjs }) => void;
  onUpClicked: () => void;
  onDownClicked: () => void;
  name: 'hour' | 'minute';
  max?: number;
  defaultValue?: string;
}

const TimeUnitInput: React.FC<TimeUnitInputProps> = (props) => {
  const {
    onChange,
    value,
    onUpClicked,
    onDownClicked,
    name,
    max,
    defaultValue = '00',
  } = props;

  const onSelectedValueChange = (evt: React.ChangeEvent<HTMLSelectElement>) => {
    const format = name === 'hour' ? 'HH' : 'mm';
    const target = {
      name: evt.target.name as 'hour' | 'minute',
      value: dayjs(evt.target.value, format),
    };
    onChange?.(target);
  };

  useEffect(() => {
    if (!value || value.trim().length === 0) {
      const target = {
        name,
        value: dayjs(dayjs().set('minute', 0), 'HH:mm'),
      };
      onChange?.(target);
    }
  }, [defaultValue, name, onChange, value]);

  return (
    <div className="flex flex-col p-4">
      <button type="button" onClick={onUpClicked}>
        <Icon icon="caret-down" className="rotate-180 text-gray300" />
      </button>
      <select
        name={name}
        value={value}
        onChange={onSelectedValueChange}
        className="px-2 outline-none appearance-none bg-transparent"
      >
        {Array.from(Array(max).keys()).map((time) => (
          <option key={time} value={time.toString().padStart(2, '0')}>
            {time.toString().padStart(2, '0')}
          </option>
        ))}
      </select>
      <button type="button" onClick={onDownClicked}>
        <Icon icon="caret-down" className="text-gray300" />
      </button>
    </div>
  );
};

export default TimeUnitInput;
